import { Component, OnInit } from '@angular/core';
import { ModalCategInscService } from './modal-categ-insc.service';
import { CategoriaInscripcionService } from '../../services/services.index';


import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

@Component({
  selector: 'app-modal-categ-insc',
  templateUrl: './modal-categ-insc.component.html',
  styles: []
})
export class ModalCategInscComponent implements OnInit {

  constructor(public _modalCategInscService: ModalCategInscService,
              public _categoriaInscripcionService: CategoriaInscripcionService) {
  }

  ngOnInit() {
  }

  guardarCategoria( form: any ) {
    this._categoriaInscripcionService.guardarCategoriaInscripcion(this._modalCategInscService.categoria).subscribe((resp: any) => {
      this._modalCategInscService.hideModal();
      swal('Categoría Guardada', 'La categoría ' + resp.nombre_es + ' ah sido actualizada correctamente.', 'success');
      this._modalCategInscService.notification.emit(resp);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal-categ-insc/modal-categ-insc.component.ts